import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import Swiper from 'swiper/bundle'
gsap.registerPlugin(ScrollTrigger)

/**
 * DropDown component.
 */
export default class DropDown {
    /**
     * Constructs a new DropDown component.
     * @param {Object} options - Options.
     * @param {HTMLElement} options.element - Container.
     */
    constructor (options) {
        this.element = options.element
        this.selectLocation = this.element.querySelector('.select-location')
        this.submit = this.element.querySelector('.submit')

        this.submit.addEventListener('click', () => {
            const url = this.selectLocation.value;
            if (url === 0 || url === "0") return;
            if (url.indexOf('http') === 0) {
                window.location.href = url;
            } else  {
                window.location.href = window.location.origin + url;
            }
        })
    }
}


// WEBPACK FOOTER //
// ./components/section/dropdown/index.js